import { ReactNode } from 'react';

interface MainTitleProps {
  children: ReactNode;
}

export const MainTitle = ({ children }: MainTitleProps) => {
  return <h1 className={'text-[2rem] font-medium leading-none'}>{children}</h1>;
};
